<template>
  <div class="my_warpper">
    <nav-bar titleText="万融解债" titleWeight="bold" @goBack="goBack"></nav-bar>
    <div class="contentBox">
      <div class="type_list">
        <van-row class="type_lis_row">
          <van-col span="16">
            <p class="debtor_title">债务人</p>
            <p class="type_list_instructions">未发布解债订单</p>
          </van-col>
          <van-col span="8">
            <div class="operati release">去发布</div>
            <div class="clear_both"></div>
          </van-col>
        </van-row>
      </div>
      <div class="type_list">
        <van-row class="type_lis_row">
          <van-col span="18">
            <p class="debtor_title">债权人</p>
            <p class="type_list_instructions">暂无解债订单</p>
          </van-col>
          <van-col span="6">
            <!-- <div class="release">去发布</div> -->
          </van-col>
        </van-row>
      </div>
      <div class="type_list">
        <van-row class="type_lis_row">
          <van-col span="18">
            <p class="debtor_title">债权人</p>
            <p class="type_list_note">解债订单待处理</p>
          </van-col>
          <van-col span="6">
            <div class="operati enter">进入</div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="footer">
      <!--申请-->
      <!-- <div class="review_row">
           <div class="review_img">
            <img src="../../../assets/debtor/user.png" alt width="20px" height="20px" />
            <span class="review_title">申请成为经纪人</span>
          </div>
      </div>-->
      <!--审核中-->

      <!-- <div class="review_row">
           <div class="review_img">
            <img src="../../../assets/debtor/user.png" alt width="20px" height="20px" />
            <span class="review_title">经纪人合同信息审核中</span>
          </div>
      </div>-->

      <!--已完成-->
      <p class="identity">- 您已成为经纪人 -</p>
      <div class="icon">
        <img src="../../../assets/debtor/user.png" width="100%" height="100%" />
      </div>
      <p class="code">3523316</p>
      <p class="agent">
        <span>进入经纪人主页</span>
        <van-icon name="arrow" />
      </p>
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
export default {
  name: "my",
  data() {
    return {};
  },
  created() {
    this.$api.post("");
  },
  components: {
    navBar,
  },
  methods: {},

  goBack() {
    // this.params("", "", "goBack");
    this.$router.go(-1);
  },
};
</script>
<style lang="less">
.my_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #fff;
  min-height: 100%;
  color: #333;
  font-size: 16px;
  // .navbar {
  //   margin: 24px 5px 0 5px;
  // }
  .contentBox {
    .type_list {
      background: #fff;
      margin: 12px 12px 0;
      padding: 27px 21px;
      border: 1px solid #eeeeee;
      border-radius: 6px;
      -webkit-box-shadow: 1px 1px 7px #dadada;
      box-shadow: 1px 1px 7px #dadada;
      .debtor_title {
        font-size: 20px;
        font-weight: 600;
        line-height: 32px;
      }
      .type_list_instructions {
        font-size: 14px;
        color: #999;
      }
      .type_list_note {
        font-size: 14px;
        color: #f9591b;
      }
      .operati {
        width: 69px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        color: #fff;
        border-radius: 30px;
        margin-top: 11px;
        float: right;
      }
      .release {
        background: #2a62fc;
      }
      .clear_both {
        clear: both;
      }
      .enter {
        background: #fc740c;
      }
    }
  }
  .footer {
    width: 100%;
    background: #fff;
    text-align: center;
    position: fixed;
    bottom: 12px;
  }
  .identity {
    padding: 15px 0;
    font-size: 16px;
    color: #cccccc;
  }
  .icon {
    margin: 0 auto 6px;
    width: 44px;
    height: 44px;
  }
  .code {
    line-height: 24px;
  }
  .agent {
    margin: 6px 0 0;
    height: 30px;
    font-size: 15px;
    line-height: 24px;
    font-weight: 600;
    span,
    .van-icon {
      vertical-align: middle;
    }
  }
  .review_row {
    // width: calc(100vw - 170px);
    margin: 0 auto;
    text-align: center;
  }
  .review_img {
    img {
      vertical-align: middle;
    }
  }
  .review_title {
    text-align: center;
    // color: #999;
    font-size: 16px;
    vertical-align: middle;
    margin-left: 8px;
  }
}
</style>





